export const getPermissionByPrefix = (prefix) => {
  try {
    const role = localStorage.getItem("roleInv");
    if (role === "company") {
      return {
        is_view: true,
        is_edit: true,
        is_add: true,
        is_delete: true,
      };
    }

    const permissions = JSON.parse(localStorage.getItem("permissionsEssential") || "[]");
    const module = permissions.find((perm) => perm.prefix === prefix);
    if (!module || !module.privileges || typeof module.privileges !== "object") {
      return {
        is_view: false,
        is_edit: false,
        is_add: false,
        is_delete: false,
      };
    }

    const {
      is_view = false,
      is_edit = false,
      is_add = false,
      is_delete = false,
    } = module.privileges;

    return { is_view, is_edit, is_add, is_delete };
  } catch (error) {
    console.error("Failed to get permissions:", error);
    return {
      is_view: false,
      is_edit: false,
      is_add: false,
      is_delete: false,
    };
  }
};
